import { z } from 'zod';
import { createPaginatedQuerySchema, } from "../../../../common/types/pagination.js";
import {} from "./companies.dto.js";
export const CompanySearchFiltersSchema = z.object({
    name: z.string().optional(),
    cnpj: z.string().optional(),
});
const PaginatedQuerySchema = createPaginatedQuerySchema(CompanySearchFiltersSchema);
export const FindCompaniesPaginatedRequestDTOSchema = z.object({
    query: PaginatedQuerySchema,
});
//# sourceMappingURL=find-companies-paginated.dto.js.map